import { COLORS } from '../../../shared/config/colors/colors';
import { styled } from 'goober';
import { LINK_BG_CLASSNAME, LINK_TEXT_CLASSNAME } from '../sidebar-link/contants';
import { HEADER_HEIGHT } from '../header/constants';
import { FAST_TRANSITION_DURATION, TRANSITION_DURATION } from './constants';

export const Wrapper = styled('nav')`
    position: fixed;
    display: flex;
    grid-area: nav;
    align-items: flex-start;
    top: ${HEADER_HEIGHT + 20}px;
    height: auto;
    z-index: 10;
`;

export const LinksList = styled('ul')<{ $linkWidth: number }>`
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 52px;
    top: 0;
    left: 20px;
    align-items: flex-start;
    border-radius: 20px;

    &::before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 52px;
        border-radius: 20px;
        background-color: transparent;
        transition: all ${TRANSITION_DURATION} ease;
    }

    .${LINK_BG_CLASSNAME} {
        width: 52px;
        transition:
            width ${FAST_TRANSITION_DURATION} ease,
            background-color ${TRANSITION_DURATION} ease;
    }

    .${LINK_TEXT_CLASSNAME} {
        pointer-events: none;
        opacity: 0;
        transition: opacity ${TRANSITION_DURATION} ease;
    }

    &:hover {
        width: auto;

        .${LINK_BG_CLASSNAME} {
            ${({ $linkWidth }) => `
                width: ${$linkWidth}px;
            `}
        }

        .${LINK_TEXT_CLASSNAME} {
            pointer-events: all;
            opacity: 1;
        }

        &::before {
            ${({ $linkWidth }) => `
                width: ${$linkWidth + 40}px;
            `}
            top: -20px;
            bottom: -20px;
            left: -20px;
            background-color: ${COLORS.neutral_00};
        }
    }
`;
